module.exports = __webpack_public_path__ + "static/img/wdsjtb1-6.9534360.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsjtb1-6.png
// module id = 877
// module chunks = 0